import Skeleton from "react-loading-skeleton"

const CargandoTabla = () => {
    return <div>
        <Skeleton active />
    </div>
}

export default CargandoTabla